import React, { useEffect } from "react";
import MiniHero from "./../MiniHero";

function PrivacyPolicy({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="Privacy Policy"
        className="fs-48 text-dark mb-5"
      />
      <div className="container py-5">
        <div className="max-width-720 mx-auto">
          <p>
            This privacy policy sets out how Tanaad Money uses and protects any
            information that you give Tanaad Money when you use this website.
          </p>
          <p>
            Tanaad Money is committed to ensuring that your privacy is
            protected. We ask you to provide certain information by which you
            can be identified when using this website, and then you can be
            assured that it will only be used in accordance with this privacy
            statement.
          </p>
          <p>
            On 25th of May, the UK/EU's new data protection regulation, the
            GDPR, will enter into force. GDPR sets higher demands on how we as a
            company treat your personal information and give you better
            opportunities to influence our management.
          </p>
          <p>What does it mean to me?</p>
          <p>In short, GDPR means that you:</p>
          <ul>
            <li className="mb-2">
              Have the right to get more detailed information about how we treat
              your personal data.
            </li>
            <li className="mb-2">
              Able to, under certain conditions, request that your personal data
              be moved or we limit the treatment
            </li>
            <li className="mb-2">
              Get stronger opportunities to access your personal data and, under
              certain conditions, get them corrected or deleted
            </li>
            <li className="mb-2">
              Can approve or contradict certain treatments that we perform, for
              example for direct marketing
            </li>
          </ul>
          <p>
            Tanaad Money may change this policy from time to time by updating
            this page. You should check this page from time to time to ensure
            that you are happy with any changes.{" "}
            <strong>This policy is effective from May 4, 2018.</strong>
          </p>
          <div>
            <h3 className="text-uppercase fs-3">What we collect</h3>
            <p>
              We require this information to understand your needs and provide
              you with a better service, and in particular for the following
              reasons:
            </p>
            <ul>
              <li className="mb-2">To process you transactions</li>
              <li className="mb-2">To verify your identity</li>
              <li className="mb-2">
                To collect payment for your use of the Service
              </li>
              <li className="mb-2">
                To provide you with information about our services
              </li>
              <li className="mb-2">
                To send you marketing notices, service updates, and promotional
                offers
              </li>
              <li className="mb-2">
                To send transaction alerts to you and/or the recipient of your
                remittance
              </li>
              <li className="mb-2">
                To comply with applicable laws, regulations, and rules, such as
                those relating to "know-your-customer", anti-money laundering
                requirements and finance of terrorism.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-uppercase fs-3">
              How we share information with others
            </h3>
            <p>
              We will not sell or rent the information we collect to third
              parties for their promotional purposes unless we receive your
              permission to do so. Nevertheless, we may share information about
              you (including non-public, non-personally identifiable
              information) with:
            </p>
            <ul>
              <li className="mb-2">
                Third-party service providers under contract with Tanaad Money
                that help us with our business operations, such as transaction
                processing, fraud prevention, email communications, live chat
                and marketing. These service providers are authorized to use
                your personal information only as necessary to provide these
                services to us.
              </li>
              <li className="mb-2">
                In the event of the sale, acquisition or merger of some or all
                of our assets, your personal information might be a part of the
                transferred assets. We shall notify you in the event of such an
                occurrence by placing a notice on our website.
              </li>
              <li className="mb-2">
                Law enforcement and government officials, but only in connection
                with a formal request, subpoena, court order, or similar legal
                procedure, as well as circumstances where we believe in good
                faith that disclosure is necessary to comply with the law,
                report suspected illegal activity, or investigate violations of
                our User Agreement.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-uppercase fs-3">Access to your information</h3>
            <p>
              You can access, modify or update your personal information
              submitted on our websites by logging in to your account and
              changing your preferences.
            </p>
          </div>
          <div>
            <h3 className="text-uppercase fs-3">Security</h3>
            <p>
              The security of your personal information is important to us. When
              you enter sensitive information (such as credit/debit card and
              banking/financial information) on our site, we encrypt the
              transmission of that information, so all information sent between
              your web browser and our website remains private and secure.
            </p>
          </div>
          <div>
            <h3 className="text-uppercase fs-3">How we use cookies</h3>
            <p>
              By using the Site you agree to our use of cookies on the Site.
              Cookies are small text files sent to your computer to identify
              your browser or to store information or settings in your browser.
              We use cookies to provide and improve the site, statistical
              purposes, provide custom / targeted marketing based on your use of
              the site, etc.
            </p>
            <p>
              You can revoke your consent to cookies at any time by changing the
              settings in your browser and you can also delete any permanent
              cookies stored on your hard drive. However, if you choose to
              configure your browser so that it does not allow the use of
              cookies, it may mean that some services may not be used or that
              the site may not work properly in all respects.
            </p>
          </div>
          <div>
            <h3 className="text-uppercase fs-3">Third party sites</h3>
            <p>
              Our websites contain links to other websites. Tanaad Money is not
              responsible for the privacy practices or the content of these
              other websites. We encourage you to familiarize yourself with the
              privacy practices of these other sites prior to submitting your
              personal information to them.
            </p>
            <p>
              Our websites include Social Media Features, such as the Facebook.
              These Features may collect your IP address, which page you are
              visiting on our site, and may set a cookie to enable the Feature
              to function properly. Social Media Features are either hosted by a
              third party or hosted directly on our websites. Your interactions
              with these Features are governed by the privacy policy of the
              company providing it.
            </p>
          </div>
          <div>
            <h3 className="text-uppercase fs-3">Contact</h3>
            <p>
              If you have any questions about this Privacy Policy or the use of
              your Personal Data, please contact us by sending an email to the
              following address
              <a className="ms-1" href="mailto: support@tanaad.com">
                support@tanaad.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
